import GlobalSpinnerService from '../common/services/spinner/global-spinner.service';
import { Action } from '../common/actions/core/action';
import { StateTransitionSucceedAction } from '../app.action';
import ActionAwareController from '../common/actions/action-aware.controller';
import ActionDispatcherService from '../common/actions/core/action-dispatcher.service';
import { ITimeoutService } from 'angular';
import { NoAuthPayByMasterpassAction } from './components/actions/masterpass.action';
import FacebookPixelService from '../common/services/analytics/facebook-analytics.service';
import GoogleAnalyticsService from '../common/services/analytics/google-analytics.service';
import HttpService from '../common/services/http.service';
import { PackageThumbnail, FamilyPlanTypes } from '../common/services/package/package.model';
import NoAuthService from './services/noauth.service';
import NotificationService from '../common/services/notification/notification.service';
import { NoAuthBuySuccessAction } from './components/buy-success-dialog/buy-success-dialog.action';
import { TimeOutError } from '../common/services/error/error.action';
import { OtpExpireAction } from './components/otp-expire-dialog/otp-expire-dialog.action';

export default class NoAuthController extends ActionAwareController {
  private viewContainerElement: JQLite;
  private msisdn;
  private packet: PackageThumbnail;

  constructor(
    private $location,
    private $translate,
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private globalSpinner: GlobalSpinnerService,
    actionDispatcher: ActionDispatcherService,
    private noAuthService: NoAuthService,
    private googleAnalytics: GoogleAnalyticsService,
    private facebookAnalytics: FacebookPixelService,
    private httpService: HttpService,
    private notificationService: NotificationService
  ) {
    super(actionDispatcher);
  }

  public $onInit() {
    this.viewContainerElement = this.$element.find('.view-container');
    super.$onInit();
    const search = this.$location.search().iframe;
    const language = this.$location.search().language;
    if (search) {
      localStorage.setItem('fizyWEB', '1');
    } else if (localStorage.getItem('fizyWEB')) {
      localStorage.removeItem('fizyWEB');
    }
    if (language) {
      this.$translate.use(language);
      this.$translate.refresh();
    }
  }

  public handle(action: Action) {
    if (action instanceof StateTransitionSucceedAction) {
      this.scrollTop();
    }
    if(action instanceof TimeOutError){
      this.actionDispatcher.dispatch(new OtpExpireAction());
    }
    if (action instanceof NoAuthPayByMasterpassAction) {
      this.msisdn = action.msisdn;
      this.packet = action.packet;
      this.globalSpinner.startIfNotActivated(true);
      this.noAuthService.startSubscription(this.msisdn, this.packet, action.card.Name, action.card.UniqueId, action.promocode).then(response => {
        this.googleAnalytics.sendGAEvent('Success', this.packet);
        this.facebookAnalytics.sendFBEvent('PremiumSatıs', null);
        const event = this.getAdjustKey();

        this.actionDispatcher.dispatch(new NoAuthBuySuccessAction(this.packet.packageSegment));
        
        this.httpService.evictResultCache('masterPackagePaymentMethod', true);
        this.httpService.evictResultCache('masterPaymentMethods', true);
      }).catch(error => {
        this.googleAnalytics.sendGAEvent('Failure', this.packet, error);
        action.onError();
        this.$translate('error.message.default').then(value => {
          this.notificationService.showNotification({
            text: value,
            type: 'warning'
          });
        });
      })
        .finally(() => this.globalSpinner.stop(true));
    }
  }

  private getAdjustKey() {
    if (this.packet.family == FamilyPlanTypes.FAMILY) {
      return 'e2oo7f';
    } else if (this.packet.family == FamilyPlanTypes.DUO) {
      return '4focid';
    } else if (this.packet.isStudent) {
      return 'gerguc';
    } else {
      return 'wnwa09';
    }
  }

  public isSpinnerActivated() {
    return this.globalSpinner.isActivated();
  }

  public headerAndFooterCheck() {
    const checkIFrame = localStorage.getItem('fizyWEB');
    const checkHeaderAndFooter = localStorage.getItem('showInApp');

    if (!checkHeaderAndFooter) {
      $("#fizyHeader, #fizyFooter").show();
    } else {
      $("#fizyHeader, #fizyFooter").hide();
    }

    return checkIFrame && checkIFrame.length > 0;
  }

  private scrollTop() {
    this.$timeout(() => {
      this.viewContainerElement.scrollTop(0);
    });
  }
}



// WEBPACK FOOTER //
// src/app/no-auth/no-auth.controller.ts